exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".visualizationBOx{position:relative}.visualizationBOx,.visualizationBOx #visualization{width:100%;height:400px}.visualizationBOx .model{width:auto;height:auto;position:absolute;right:0;top:0;color:#29327f;padding-right:3%;padding-top:3%;font-size:14px}@media only screen and (max-width:787px){.visualizationBOx,.visualizationBOx #visualization{height:300px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4e13b688","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/vis.vue
// module id = LA6v
// module chunks = 1